import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { contractingNoteKeys } from "@/lib/query-keys";
import type { ContractingNote } from "@/types/domain";

/** Los comentarios de una licitación, más reciente primero. */
export function useContractingNotes(contractingId?: number) {
  return useQuery({
    queryKey: contractingNoteKeys.byContracting(contractingId),
    enabled: contractingId != null,
    queryFn: () =>
      fetchToBackend<ContractingNote[]>(`/contractingnotes/${contractingId}`),
  });
}
